import { useTopBarLinks } from '@bridebook/web/app-basic/lib/hooks/use-top-bar-links';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import { type FC, type ReactNode } from 'react';
import { cn } from '@bridebook/aura';
import { BurgerSpriteIcon } from '@bridebook/web/app-basic/components/header/header-svg-sprite';
import BasicSignUpLink, {
  BasicSignUpLinkMode,
} from '@bridebook/web/app-basic/components/signup-link/basic-sign-up-link';
import { Link } from '@bridebook/web/app-shared/components/link/link';
import { env } from '@bridebook/web/lib/env';

interface IProps {
  onBurgerClick?: () => void;
}

const AuthButton = ({
  showLogin,
  clickedLocation,
  mode,
  className,
  children,
}: {
  showLogin?: boolean;
  clickedLocation?: string;
  mode: BasicSignUpLinkMode;
  className?: string;
  children: ReactNode;
}) => (
  <BasicSignUpLink showLogin={showLogin} clickedLocation={clickedLocation} mode={mode}>
    <button className={cn('bcb', className)}>{children}</button>
  </BasicSignUpLink>
);

const TopBarLoggedOutButtons: FC<IProps> = ({ onBurgerClick }) => {
  const { t } = useTranslation('common');
  const { asPath } = useRouter();

  const links = useTopBarLinks();

  return (
    <div className="bcbtns">
      <div className="bcnav">
        {links.map((link) => {
          const isActive = asPath.endsWith(link.url);
          return (
            <Link
              key={link.nameShort}
              href={link.url}
              className={cn('bct bctnav', isActive && 'bctnav-active')}>
              {link.name}
            </Link>
          );
        })}
      </div>
      <div className="bcact">
        <Link href={`${env.CMS_URL}/login`} className="bct bctbiz">
          {t('businessLogin')}
        </Link>
        <AuthButton showLogin mode={BasicSignUpLinkMode.DesktopOnly} className="bcl">
          {t('button.login')}
        </AuthButton>
        <AuthButton
          clickedLocation="topMenuSignUpButton"
          mode={BasicSignUpLinkMode.Inline}
          className="bcs">
          {t('button.signup')}
        </AuthButton>
        <button
          type="button"
          data-test="landing-header-burger-nav"
          onClick={onBurgerClick}
          className="bcb bck">
          <BurgerSpriteIcon width={24} viewBox="0 0 14 11.6" />
        </button>
      </div>
    </div>
  );
};

export default TopBarLoggedOutButtons;
